import "./cardProject.scss"

export const CardProject = ({project}) => {
  return (
    <div className="container" data-aos="fade-up-right">
      <div className="card">
        <div className="image">
          <img
            href="#"
            src={project.img}
            alt="imgProject"
          />
        </div>
        <div className="content">
          <h3>{project.title}</h3>
          <p>
            {project.tools.map(tool=>(
              <span>{tool}</span>
            ))}
          </p>
          <a href={project.demo} target="_blank" rel="noreferrer">Demo</a>
        </div>
      </div>
    </div>
  );
};
